<template>
  <div class="body-custom-item">
    <div class="item-title">
      Event submission message
    </div>
    <div class="item-subtitle">
      You are submitting event <span class="blue">(Event name here)</span> for approval.
    </div>
    <div class="item-body-detail">
      <vue-editor id="submission-message" v-model="message" :class="isDefault ? 'default-message' : null"></vue-editor>
    </div>
    <div class="grp-button-action">
      <b-button class="item-reset-btn" @click="resetMessage()">
        <span class="dt-group-btn-func-btn-left-text">RESET MESSAGE</span>
      </b-button>
      <b-button class="item-save-btn dt-group-btn-func-btn-right" @click="saveMessage('SUBMISSION')"
                :disabled="!canSave">
        <Icon name="file-text-o"></Icon>
        <span class="dt-group-btn-func-btn-left-text">SAVE MESSAGE</span>
      </b-button>
      <b-button class="item-cancel-btn" @click="hideModal()">
        <span class="dt-group-btn-func-btn-left-text">CANCEL</span>
      </b-button>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/file-text-o';
  import {VueEditor} from 'vue2-editor';
  import Icon from 'vue-awesome/components/Icon';
  import constant from '../../_consts';

  export default {
    name: '',
    components: {
      Icon,
      VueEditor
    },
    data () {
      return {
        canSave: true,
        message: '',
        isDefault: false
      }
    },
    props: {
      content: {
        type: String,
        default: ''
      }
    },
    methods: {
      saveMessage (type) {
        this.$emit('UPDATE_MESSAGE', {
          type: type,
          content: this.message
        });
      },
      hideModal () {
        this.$modal.hide('customMessageModal');
      },
      resetMessage () {
        this.message = constant.defaultModalMessage.submissionMessage;
        this.saveMessage('SUBMISSION');
      }
    },
    computed: {},
    mounted () {
      this.message = this.content;
    },
    watch: {
      message: {
        handler: function () {
          if (this.message === '<p><br></p>') {
            this.canSave = false;
          } else {
            this.canSave = true;
          }
          if (this.message === constant.defaultModalMessage.submissionMessage) {
            this.isDefault = true;
          } else {
            this.isDefault = false;
          }
        }
      }
    }
  }
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .body-custom-item {
    .item-title {
      height: 20px;
      color: #444444;
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
    }
    .item-subtitle {
      height: 24px;
      color: #424242;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 24px;
      margin-top: 10px;
      .blue {
        color: @blue;
        font-weight: 600;
      }
    }
    .item-body-detail {
      margin-top: 5px;
      border: solid 1px #cccccc;
      border-radius: 5px;
      font-family: 'Open Sans', sans-serif;
    }

    .quillWrapper {
      border: none;
      font-family: 'Open Sans', sans-serif;
    }

    .ql-toolbar.ql-snow {
      border-top: none;
      border-right: none;
      border-left: none;
    }

    .ql-container.ql-snow {
      border-bottom: none;
      border-right: none;
      border-left: none;
    }
    .grp-button-action {
      margin-top: 8px;
      .item-reset-btn {
        background-color: #AAA7A4;
        float: left;
        span {
          color: #FFFFFF;
          font-size: 16px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
          letter-spacing: 0.1px;
          font-weight: 600;
        }
      }
      .item-cancel-btn {
        border: 1px solid #00A4D6;
        border-radius: 4px;
        background-color: #FFF;
        float: right;
        span {
          font-weight: 600;
          color: #00A4D6;
          font-size: 16px;
          letter-spacing: 0.1px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
        }
      }
      .item-save-btn {
        background-color: #00A4D6;
        float: right;
        margin-left: 16px;
        svg {
          color: #FFFFFF;
          font-size: 18px;
          line-height: 18px;
        }
        span {
          color: #FFFFFF;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CustomMessageSectionSubmission.vue?7f2125e8